export const defaultMetaConfig = {
  appName: 'Play SRF',
  appSchemeUrl: 'playsrf',
  iosAppStoreId: '638194352'
};
export const metaImageWidth = 960;